module.exports = __webpack_public_path__ + "img/incident-statistics-bg.e865fd98.jpg";